import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useDialog } from "./DialogProvider";
import withIntl from "../../utils/withIntl";
import { DialogActions, DialogContent, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import EditTextField from "../EditArticle/EditTextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  rootTitle: { marginRight: 40 },
}));

function EditTextFieldDialog(props) {
  const classes = useStyles();
  const [, closeDialog] = useDialog();
  const [value, setValue] = React.useState("");

  return (
    <>
      <DialogTitle id="simple-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"} classes={{ h5: classes.rootTitle }}>
            {props.fieldTitle}
            {props.defaultLanguage && (
              <span style={{ display: "block", fontSize: 12, fontWeight: "normal" }}>
                *{props.intl.formatMessage({ id: "default_language" })}:
                {props.intl.formatMessage({ id: props.defaultLanguage })}
              </span>
            )}
          </Typography>
        </div>
      </DialogTitle>
      <IconButton
        onClick={() => closeDialog()}
        color="primary"
        style={{ position: "absolute", top: "8px", right: "8px" }}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <div style={{ margin: 10 }}>
          <EditTextField
            autoFocus
            fullWidth
            label={props.label ? props.label : null}
            value={value}
            onBlur={(value) => {
              setValue(value);
            }}
            variant={"standard"}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.handleOnClick(value);
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "add" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(EditTextFieldDialog);
